module.exports = __webpack_public_path__ + "static/media/DENT.4e233671.svg";